import { gql } from 'graphql-tag';

// Mutation to start the export job
export const EXPORT_TRACK_EVENTS = gql`
  mutation GetTrackEventsReport($input: GetAccountEventsInput!) {
    getTrackEventsReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const EVENTS_EXPORT_STATUS = gql`
  subscription TrackEventsExportStatus($jobId: String!) {
    trackEventsExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL (if not provided in subscription)
export const GET_EVENTS_EXPORT_DOWNLOAD_URL = gql`
  query GetTrackEventsExportDownloadUrl($jobId: String!) {
    getTrackEventsExportDownloadUrl(jobId: $jobId)
  }
`;
